import range from "lodash-es/range";

export enum ColorStyle {
  STATUS = "status",
  MANUAL = "manual",
}

export enum ValueKeys {
  FONT_SIZE = "fontSize",
  COLOR_STYLE = "colorStyle",
  COLOR = "color",
}

export const fontSizes = range(9, 30, 1).map((size) => ({
  value: size,
  label: size,
}));

export const colorStyles = [
  { value: ColorStyle.STATUS, label: "ステータスの色" },
  { value: ColorStyle.MANUAL, label: "色を指定" },
];

export enum ColorType {
  TYPE_1,
  TYPE_2,
  TYPE_3,
  TYPE_4,
  TYPE_5,
  TYPE_6,
  TYPE_7,
  TYPE_8,
  TYPE_9,
  TYPE_10,
  TYPE_11,
  TYPE_12,
}

export interface Color {
  id: number;
  backgroundColor: string;
  color: string;
  borderColor: string;
}

export const ColorStyleOptions: Color[] = [
  {
    id: ColorType.TYPE_1,
    backgroundColor: "#000000",
    color: "#FFF",
    borderColor: "transparent",
  },
  {
    id: ColorType.TYPE_2,
    backgroundColor: "#808080",
    color: "#FFF",
    borderColor: "transparent",
  },
  {
    id: ColorType.TYPE_3,
    backgroundColor: "#FFFFFF",
    color: "#000",
    borderColor: "#000000",
  },
  {
    id: ColorType.TYPE_4,
    backgroundColor: "#FEF35C",
    color: "#000",
    borderColor: "transparent",
  },
  {
    id: ColorType.TYPE_5,
    backgroundColor: "#F8C739",
    color: "#000",
    borderColor: "transparent",
  },
  {
    id: ColorType.TYPE_6,
    backgroundColor: "#EE4C32",
    color: "#000",
    borderColor: "transparent",
  },
  {
    id: ColorType.TYPE_7,
    backgroundColor: "#D61864",
    color: "#FFF",
    borderColor: "transparent",
  },
  {
    id: ColorType.TYPE_8,
    backgroundColor: "#6331AF",
    color: "#FFF",
    borderColor: "transparent",
  },
  {
    id: ColorType.TYPE_9,
    backgroundColor: "#389BEC",
    color: "#FFF",
    borderColor: "transparent",
  },
  {
    id: ColorType.TYPE_10,
    backgroundColor: "#32CCD3",
    color: "#000",
    borderColor: "transparent",
  },
  {
    id: ColorType.TYPE_11,
    backgroundColor: "#26A68A",
    color: "#FFF",
    borderColor: "transparent",
  },
  {
    id: ColorType.TYPE_12,
    backgroundColor: "#92D05B",
    color: "#000",
    borderColor: "transparent",
  },
];
